import { Progress } from "tamagui";

import { TextTestID } from "@/constants/TestID";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ProgressBarProps extends ViewWithTestID {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ currentStep, testID, totalSteps }: ProgressBarProps) => {
  const baseTestID = joinTestIDs(testID, TextTestID.ProgressBar);

  return (
    <Progress
      backgroundColor={ColorToken.NeutralLine}
      height={8}
      testID={baseTestID}
      value={(currentStep / totalSteps) * 100}
    >
      <Progress.Indicator
        backgroundColor={ColorToken.ButtonPrimaryActive}
        borderRadius={4}
        height="100%"
      />
    </Progress>
  );
};

export default ProgressBar;
export type { ProgressBarProps };
